import { render, staticRenderFns } from "./JsmCard.vue?vue&type=template&id=1e042e3f&scoped=true&"
import script from "./JsmCard.vue?vue&type=script&lang=js&"
export * from "./JsmCard.vue?vue&type=script&lang=js&"
import style0 from "./JsmCard.styl?vue&type=style&index=0&id=1e042e3f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e042e3f",
  null
  
)

export default component.exports